import { StatusDtoOrderStatusEnum } from 'utils/types/OrderModels';

import { PurchaseProductEnum, UIStatus } from './PurchaseStatusInfo';

export const getPurchaseStatusInfoTitle = (orderStatus: string, purchaseType: PurchaseProductEnum, isPolling: boolean, isNewAccount?: boolean): string => {
    switch (orderStatus) {
    case StatusDtoOrderStatusEnum.PAID:
    case StatusDtoOrderStatusEnum.COMPLETED:
        switch (purchaseType) {
        case PurchaseProductEnum.SUBSCRIPTION: return isNewAccount ? 'Konto utworzone i subskrypcja aktywowana!' : 'Subskrypcja aktywowana!';
        case PurchaseProductEnum.SMS: return 'SMS-y dodane do konta!';
        case PurchaseProductEnum.TOKENS: return 'Tokeny AI dodane do konta!';
        }
        break;
    case StatusDtoOrderStatusEnum.FAILED:
    case StatusDtoOrderStatusEnum.CANCELLED:
    case StatusDtoOrderStatusEnum.EXPIRED:
        return 'Wystąpił problem';
    case StatusDtoOrderStatusEnum.PENDING:
        return isPolling ? 'Oczekiwanie na potwierdzenie płatności' : 'Przetwarzanie płatności';
    case StatusDtoOrderStatusEnum.REGISTERED:

    default:
        switch (purchaseType) {
        case PurchaseProductEnum.SUBSCRIPTION: return isNewAccount ? 'Tworzenie konta i aktywacja subskrypcji' : 'Aktywacja subskrypcji';
        case PurchaseProductEnum.SMS: return 'Dodawanie SMS-ów do konta';
        case PurchaseProductEnum.TOKENS: return 'Dodawanie tokenów AI do konta';
        }
    }

    return 'Przetwarzanie...';
};

export const getPurchaseInfoMessage = (purchaseType: PurchaseProductEnum, uiStatus: UIStatus, error?: string): { title: string; content: string } => {
    switch (uiStatus) {
    case UIStatus.SUCCESS:
        switch (purchaseType) {
        case PurchaseProductEnum.SUBSCRIPTION:
            return {
                title: '🎉 Subskrypcja aktywna',
                content: 'Masz teraz pełny dostęp do wszystkich funkcji Skanera Okazji przez 12 miesięcy.'
            };
        case PurchaseProductEnum.SMS:
            return {
                title: '📱 SMS-y dostępne',
                content: 'SMS-y zostały dodane do Twojego konta i są gotowe do użycia.'
            };
        case PurchaseProductEnum.TOKENS:
            return {
                title: '🤖 Tokeny AI dostępne',
                content: 'Tokeny AI zostały dodane do Twojego konta.'
            };
        }
        break;
    case UIStatus.ERROR:
        return {
            title: '❌ Błąd',
            content: error || 'Wystąpił problem z realizacją płatności. Środki nie zostały pobrane z Twojego konta.'
        };
    case UIStatus.POLLING:
        return {
            title: '💡 Płatność w toku',
            content: 'Proces może potrwać do kilku minut.'
        };
    case UIStatus.PROCESSING:
    default:
        return {
            title: '⏳ Przetwarzanie',
            content: 'Przetwarzamy Twoją płatność. Nie zamykaj tej strony.'
        };
    }
};
